import { Box, Dialog, IconButton, Slide, Typography, useTheme } from '@mui/material'
import React, { useState } from 'react'

import { Icons } from '../../../utils/utilities'
import VideoPlayer from '../../../components/common/video-player/VideoPlayer'
import HybridClassVideoQuizPopover from '../../../components/webinar-room/hybrid-class/HybridClassVideoQuizPopover'
import AccessEndTimeTracker from './AccessEndTimeTracker'
import VideoProgressSyncFailureDialog from './VideoProgressSyncFailureDialog'
import { videoPlayerControls } from '../../../shared/utils/constants'

const HybridClassVideoPlayerDialog = ( {
    src,
    video,
    videoDefaults,
    videoCompleted = false,
    upNextBadgeDetails,
    eventPopupDetails,
    onClose,
    onTakeQuiz,
    onQuizPopoverClose,
    onRateChange,
    onTimelineEvent,
    onEnded,
    onTimeUpdate,
    canRequestExtension,
    extensionRequest,
    requestingExtension,
    onRequestExtension,
    progressSyncFailing,
} ) => {

    // State (not a ref) so VideoPlayer and the tracker re-render once the paper is mounted
    const [paperEl, setPaperEl] = useState( null )

    const { palette, layout } = useTheme()

    if ( !src || !video ) return null

    return (
        <Dialog disableRestoreFocus fullScreen open={Boolean( src )}
            slotProps={{
                paper: {
                    ref: setPaperEl,
                    className: "full-viewport",
                    sx: {
                        background: `rgba(255,255,255,0.3)`,
                        backdropFilter: "blur(5px)"
                    }
                }
            }} >

            {eventPopupDetails && <HybridClassVideoQuizPopover handleClose={onQuizPopoverClose} open={Boolean( eventPopupDetails )} anchorEl={eventPopupDetails.anchorEl} eventPopupDetails={eventPopupDetails} />}

            <Box position="absolute" zIndex={10} top={layout.pagePadding} borderRadius="50%" right={layout.pagePadding} bgcolor={palette.contentBg + 88}>
                <IconButton onClick={onClose} sx={{ color: palette.common.bg }} >
                    {Icons.default.CloseIcon}
                </IconButton>
            </Box>

            <AccessEndTimeTracker
                key={video.id + "access-end-tracker"}
                recordingDetails={video}
                containerEl={paperEl}
                videoCompleted={videoCompleted}
                canRequestExtension={canRequestExtension}
                extensionRequest={extensionRequest}
                requestingExtension={requestingExtension}
                onRequestExtension={onRequestExtension}
            />

            <VideoProgressSyncFailureDialog key={video.id + "progress-sync"} failing={progressSyncFailing} />

            <Slide in={Boolean( upNextBadgeDetails ) && upNextBadgeDetails?.type === "quiz"} >
                <Box position="absolute" padding="10px 20px" display="flex" gap="10px" alignItems="center" zIndex={10} top={layout.pagePadding} borderRadius="30px" left={layout.pagePadding} bgcolor={palette.common.bg}>
                    <Box>
                        <Typography fontSize="8px" color='textSecondary' fontWeight="400">UP NEXT</Typography>
                        <Typography fontSize="16px" fontWeight="700">Quiz</Typography>
                    </Box>
                    <IconButton onClick={onTakeQuiz}>
                        {Icons.default.QuizIconOutlined}
                    </IconButton>
                </Box>
            </Slide>

            <VideoPlayer
                fullscreenElement={paperEl}
                key="hybrid-class-video-player"
                onRateChange={onRateChange}
                onEvent={onTimelineEvent}
                events={video.video_timeline_events}
                title={video.title}
                containerHeight="100%"
                controllerOptions={videoPlayerControls}
                autoPlay
                onEnded={onEnded}
                defaults={videoDefaults}
                onTimeUpdate={onTimeUpdate}
                src={src}
            />
        </Dialog>
    )
}

export default HybridClassVideoPlayerDialog